if (!customElements.get('slideshow-component')) {
  customElements.define('slideshow-component', class SlideshowComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.slider');
      this.sliderItems = this.querySelectorAll('.slider__slide');
      this.currentIndex = 0;
      this.autoplay = this.dataset.autoplay === 'true' || 
                      this.slider?.dataset.autoplay === 'true';
      this.speed = (parseInt(this.slider?.dataset.speed) || 5) * 1000;
      this.prevBtn = this.querySelector('.slider-button--prev');
      this.nextBtn = this.querySelector('.slider-button--next');
    }

    connectedCallback() {
      if (this.sliderItems.length <= 1) return;
      this.initSlider();
      if (this.autoplay) this.startAutoplay();
      this.addSwipeSupport();
    }

    initSlider() {
      this.showSlide(0);
      this.prevBtn?.addEventListener('click', () => this.prev());
      this.nextBtn?.addEventListener('click', () => this.next());
    }

    showSlide(index) {
      this.sliderItems.forEach((slide, i) => {
        slide.style.display = i === index ? 'block' : 'none';
        slide.setAttribute('aria-hidden', i !== index);
      });
      this.currentIndex = index;
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.sliderItems.length;
      this.showSlide(nextIndex);
    }

    prev() {
      const prevIndex = (this.currentIndex - 1 + this.sliderItems.length) % this.sliderItems.length;
      this.showSlide(prevIndex);
    }

    startAutoplay() {
      this.autoplayInterval = setInterval(() => this.next(), this.speed);
    }

    stopAutoplay() {
      clearInterval(this.autoplayInterval);
    }

    addSwipeSupport() {
      let startX = 0;
      this.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        this.stopAutoplay();
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          diff > 0 ? this.next() : this.prev();
        }
        if (this.autoplay) this.startAutoplay();
      }, { passive: true });
    }
  });
}
